const CONDITIONS = {
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
};

const TYPES = {
  DISCOUNT: 'Discount',
  TAX: 'Tax',
  FEE: 'Fee',
};

const DISCOUNT_ADJUSTMENT = {
  condition: CONDITIONS.NEGATIVE,
  type: TYPES.DISCOUNT,
  title: TYPES.DISCOUNT,
};

const TAX_ADJUSTMENT = {
  condition: CONDITIONS.POSITIVE,
  type: TYPES.TAX,
};

const FEE_ADJUSTMENT = {
  condition: CONDITIONS.POSITIVE,
  type: TYPES.FEE,
  title: TYPES.FEE,
};

const FEE_DEFAULT_LABEL = 'fee';

export default {
  CONDITIONS,
  TYPES,
  DISCOUNT_ADJUSTMENT,
  TAX_ADJUSTMENT,
  FEE_ADJUSTMENT,
  FEE_DEFAULT_LABEL,
};
